<template>
    <div>
        <registration-form :baseUrl="base_url" :eventId="event_id" />
    </div> 
</template>


<script>
import Vue from 'vue';
import Vuex from 'vuex';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueFlatPickr from 'vue-flatpickr-component';
// import RegistrationForm from './components/RegistrationForm.vue';
import RegistrationForm from './components/RegistrationFormV2.vue';
import VTooltip from 'v-tooltip'
import vClickOutside from 'v-click-outside';
Vue.use(Vuex);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueFlatPickr);
Vue.use(VTooltip);
Vue.use(vClickOutside);
const store=new Vuex.Store({
//   state: {
//       base_url:'',
//       api_url:'',
//       api_token:''
//   },
//   mutations: {
//     setapiUrl: function(state, value){
//       state.base_url=value;
//     },
//     setApiToken: function(state, value){
//       state.api_token=value;
//     }
    
//   }
});

export default {
    store,
    name: 'event-registration-form',
    props: ['base_url','event_id'],
    metaInfo() {
        return{
            title: this.title,
            htmlAttrs: {
                lang: 'en-US'
            },
            meta: [
                { charset: 'utf-8' },
                { name: 'description', content: 'SamsCrm, SamsCrm.' },
                { name: 'viewport', content: 'width=device-width, initial-scale=1.0, user-scalable=no, minimum-scale=1.0, maximum-scale=1.0' }
            ],
            link: [
                // { rel: 'stylesheet', href: '/css/index.css' },
                { rel: 'icon', href: this.short_icon }
            ]

        }
    },
    components:{
        RegistrationForm
    },
    data(){
        return{
        }
    },
    created(){
        var ref = this;
        // ref.$store.commit('setapiUrl', ref.base_url);
		// ref.$store.commit('setApiToken', ref.api_token);
        // this.setup_urls();
        ref.short_icon = ref.apiUrl('/assets/custom/img/branding.ico')
    },
    mounted(){
    },
    methods:{
        
       
    }
}
</script>
<style>
    @import "~bootstrap-vue/dist/bootstrap-vue.css";
    @import "~flatpickr/dist/flatpickr.min.css";
    @import "~boxicons/css/boxicons.min.css";
    @import "~noty/lib/noty.css";
    @import "~noty/lib/themes/sunset.css";
    @import "~@riophae/vue-treeselect/dist/vue-treeselect.css";

    /* end */


    /* Import from static folder */

    @import "../../static/assets/css/bootstrap.min.css";
    /* @import "../../static/assets/css/font-awesome.min.css"; */
    @import "../../static/assets/css/font-awesome-4-7-0.min.css";
    @import "../../static/waitMe/waitMe.min.css";
    /* @import "../../static/assets/img/branding.ico"; */
    @import "../../static/assets/css/new_nav.css";

    @import "../../static/assets/css/lobipanel.min.css";
    @import "../../static/assets/css/vendor/lobipanel.min.css";
    @import "../../static/assets/css/pages/widgets.min.css";
    @import "../../static/assets/css/main.css";
    @import "../../static/assets/css/custom.css";
    @import "../../static/assets/css/custom_style.css";
    @import "../../static/assets/css/full_profile.css";
    @import "../../static/assets/css/lead_profile.css";
    @import "../../static/assets/css/profile.min.css";
    @import "../../static/assets/css/pnotify.min.css";
    @import "../../static/assets/css/pretty-checkbox.min.css";
    @import "../../static/assets/css/rcswitcher.css";

    @import "../../static/assets/css/glyphicon.css";

    @import url('https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap');
    body {
        background: #fff !important;
    }

    .groupBtn button {
        font-size: 13px;
        padding: 7px 5px;
    }

    .time_div {
        padding-left: 0px;
        padding-right: 0px;
    }

    .time_div .alert.alert-grey-darker {
        border-color: #fff;
        background-color: #f6f8fa;
        border-right-color: #919fa9;
    }

    #right_btn_group {
        padding: 7px;
    }

    #table_header {
        padding: 7px 3px;
    }

    .box-2 {
        width: 12% !important;
    }

    .box-3 {
        width: 71px;
    }

    .box-4 {
        width: 100px !important;
    }

    .box-5 {
        width: 107px;
    }

    .box-6 {
        width: 79px;
    }

    .box-7 {
        width: 52px;
    }

    .box-8 {
        width: 52px;
    }

    .student_list .bordered-box .inner-box {
        padding: 5px 0px;
        align-self: center;
    }

    .bordered-box {
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        border-bottom: 1px solid #d8e2e7 !important;
        justify-content: space-between;
    }

    .student_list .bordered-box .inner-box {
        border-left: none;
    }

    .student_list .top-head .bordered-box {
        background: none;
    }

    #tab .btn-default-outline {
        padding: 4px 5px !important;
        font-size: small;
        background: #f2f3f5;
    }

    .tick_icon .fa-check-circle {
        color: #28a745;
    }

    .img_box {
        text-align: left !important;
        margin-left: 16%;
    }

    .box-5 .label-light {
        padding: .1em .1em;
        font-size: 10px;
    }

    .contact-row-list p {
        font-size: 11px;
        font-weight: bold;
        color: #343434;
    }

    .lobipanel .panel-heading {
        /*padding: 9px 11px!important;*/
        padding: 3px 8px !important;
    }

    .lobipanel .panel-heading b {
        font-size: .9rem;
    }

    #task_statistic_div {
        /*padding: 2% 8% 2% 2%;*/
        padding: 2% 6% 2% 6%;
    }

    .progress-val {
        font-size: .7rem;
    }

    #task_statistic1 {
        padding-right: 1%;
        border-bottom: 1px solid #c7c7c785;
        padding-bottom: 4%;
        padding-top: 4%;
    }

    #task_statistic2 {
        padding-left: 1%;
        border-bottom: 1px solid #d8e2e7;
        padding-bottom: 4%;
    }

    #task_statistic3 {
        padding-right: 1%;
        border-right: 1px solid #d8e2e7;
        padding-top: 4%;
    }

    #task_statistic4 {
        padding-left: 1%;
        padding-top: 4%;
    }

    .nav-tabs {
        border-bottom: none;
    }

    .btn.btn-default-outline:focus {
        /*background: #988cde !important;*/
        background: #00a8ff !important;
    }

    /* .box-typical.box-typical-dashboard .box-typical-header{
        background: #dedbf1;
    } */
    .box-typical.box-typical-dashboard .box-typical-header {
        border-bottom: solid 1px #c7c7c785;
    }

    .box-typical {
        background: unset;
    }

    .box-typical.box-typical-dashboard {
        margin: 0 0 19px;
        overflow: hidden;
    }

    .crm_type_img {
        width: 12%;
        margin-top: -2%;
        margin-right: 3%;
    }

    .course_extra_btn_div {
        width: 12%;
        background: #d8dade;
        position: absolute;
        left: 20%;
        height: 10%;
        top: -1px;
        border: 2px solid #f2f3f5;
        border-radius: 18%;
        cursor: pointer;
    }

    .course_extra_btn_div .fa-pie-chart {
        color: #a1adb5;
        margin-top: 21%;
        margin-left: 20%;
    }

    .header_div {
        position: relative;
    }

    .crm_extra_btn_div {
        width: 11%;
        background: #d8dade;
        position: absolute;
        left: 16%;
        height: 10%;
        top: -1px;
        border: 2px solid #f2f3f5;
        border-radius: 18%;
        cursor: pointer;
    }

    .crm_extra_btn_div span {
        color: lightslategray;
        font-size: .6rem;
        line-height: 3;
    }

    .panel-footer a {
        color: #adb7be !important;
    }

    .panel-footer {
        border-top: none !important;
    }

    #typical_tbl tbody tr td {
        padding: 6px 5px;
    }

    #typical_tbl tbody tr td strong {
        font-size: .7rem;
    }

    .agent_summary_img {
        width: 25px;
        border-radius: 50%;
        margin-right: 2%;
    }

    .recomendations-slider-prev,
    .recomendations-slider-next {
        background: #fff;
        border: none;
    }

    .recomendations-slider-prev .font-icon-arrow-left {
        color: #c5d6de;
    }

    .recomendations-slider-next .font-icon-arrow-right {
        color: #c5d6de;
    }

    .events_div .event_title {
        font-size: .8rem;
    }

    .event_info_div ul li {
        font-size: .8rem;
        margin-bottom: 7%;
        color: #91a1b0;
    }

    .events_div dd {
        margin-left: 0;
        font-size: 12px;
        color: #91a1b0;
    }

    .events_div dt {
        font-size: .8rem;
    }

    .events_div .market_flag {
        width: 11%;
        margin-top: 3px;
        margin-right: 3%;
        height: 13px;
    }

    .market_country ul li {
        font-size: .9rem;
        margin-bottom: 1%;
    }

    .market_country ul li .fa-trash,
    .fa-hand-paper-o {
        color: #91a1b0;
    }

    .lead_tbl_body,
    .app_tbl_body,
    .course_tbl_body,
    .crm_tbl_body,
    .summary_tbl_body tr td {
        font-size: 12px;
        font-weight: 600;
    }

    .lead_tbl_body,
    .app_tbl_body,
    .course_tbl_body .bootstrap-table .table td,
    .fixed-table-body .table td,
    .table td {
        height: 36px;
    }

    .uni_tbl_body,
    .city_tbl_body tr td {
        font-size: 12px;
        font-weight: 600;
    }

    .uni_tbl_body tr td {
        font-size: 12px;
        font-weight: 600;
    }

    .uni_flag,
    .city_flag {
        width: 16%;
        height: 10px;
        margin-top: -2%;
        margin-right: 3%;
    }

    /*New Font Style*/
    .tbl-cell-title h3 {
        font-size: 13px !important;
        font-weight: bold !important;
    }

    .box-typical-header b {
        font-size: 11px !important;
        font-weight: bold !important;
    }

    /*New Font Style*/
    #tab .btn-default-outline {
        border-radius: 0;
    }

    #top_performer_div .profile-card-photo {
        margin-top: 10px;
    }

    #top_performer_div .profile-card-photo img {
        height: 30%;
        width: 30%;
        margin: 0 auto;
        border-radius: 50%;
    }

    #top_performer_div h5 {
        font-size: medium;
        color: #545858;
        font-weight: 400;
        margin-top: 7%;
    }

    .fc-center {
        position: absolute;
        left: 0;
    }

    .fc button {
        height: 22px !important;
    }

    .fc-center h2 {
        padding: 0;
        font-size: .9rem;
    }

    .fc-state-active {
        /*background: #988cde;*/
        background: #00a8ff;
        color: #fff;
    }

    .course_btn_div {
        padding: 2px 7px;
        border: none;
        background: #fff;
    }

    .course_btn_div_active {
        padding: 4px 5px;
        border: none;
        background: #d8dade;
        border-radius: 5%;
    }

    .course_extra_btn_div_active {
        background: #fff;
    }

    .crm_btn_div {
        padding: 2px 5px;
        border: none;
        background: #fff;
    }

    .crm_btn_div_active {
        padding: 4px 5px;
        border: none;
        background: #d8dade;
        border-radius: 5%;
    }

    .crm_extra_btn_div_active {
        background: #fff;
    }

    .nav-tabs .btn-default-outline:first-child {
        border-bottom-left-radius: 10% !important;
        border-top-left-radius: 10% !important;
    }

    .nav-tabs .btn-default-outline:last-child {
        border-bottom-right-radius: 10% !important;
        border-top-right-radius: 10% !important;
    }

    .btn-default-outline.active:link,
    .btn-default-outline.active:visited {
        background: #988cde !important;
        background: #00a8ff !important;
        color: #fff;
    }

    .per_top_div {
        min-height: 98px;
    }

    #time_slide {
        padding: 15px 18px 0px 5px;
    }

    #thirty_days_btn {
        background: #fff !important;
        color: black !important;
        border: none !important;
        cursor: auto !important;
        font-size: 11px !important;
        display: none;
    }

    .lead_tbl_body tr td,
    .app_tbl_body tr td,
    .course_tbl_body tr td,
    .crm_tbl_body tr td,
    .uni_tbl_body tr td,
    .city_tbl_body tr td,
    .summary_tbl_body tr td {
        font-weight: 400;
    }

    #right_btn_group .btn.btn-default-outline {
        border-color: #fff;
    }

    /*New Style*/
    .crm_left_part {
        display: grid;
        margin-top: 7%;
    }

    .crm_left_part_icon {
        color: #625f8b;
        font-size: large;
    }

    .crm_left_part_text {
        font-size: 11px;
        font-weight: 600;
        color: #2a2929;
    }

    #task_statistic1:last-child {
        border-bottom: none;
    }

    .box-typical.box-typical-dashboard {
        border: none;
    }

    /* .q_form {
        cursor: pointer;
    } */

    .q_form .fa-bolt {
        display: block;
        font-size: 17px;
        color: rgb(46 17 83);
    }

    .q_form .glyphicon-class {
        font-size: 12px;
        color: rgb(46 17 83);
    }

    /* .q_form:hover * {
        color: #ff7f00 !important;
        transition: all 1s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    } */


    .label_badge_radius {
        background-image: linear-gradient(to right, #afa6ec, #ffffff);
        color: rgb(91 91 91);
        border-radius: 20px;
        padding: 1px 10px;
        font-size: 11px;
        font-weight: 600;
        line-height: 1.3;
        letter-spacing: .2px;
    }

    .title_hover_task {
        line-height: 19px;
        color: black !important;
    }

    .title_hover_task:hover {
        color: #ff7f00 !important;
        transition: all 1s cubic-bezier(0.19, 1, 0.22, 1) 0s;
    }

    .welcome_msg_box {
        /*box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;*/
        box-shadow: rgb(0 0 0 / 40%) 0 22px 20px -23px;
    }

    .welcome_msg_box .welcome_agent_text {
        font-size: 16px;
        font-weight: 600;
        display: block;
    }

    .welcome_msg_box #message {
        font-size: 13px;
    }

    .welcome_msg_box .gradient-heading {
        /*background: -o-linear-gradient(45deg,#ff8a00,#e52e71,#044bea,#7a00ff);*/
        background: -o-linear-gradient(45deg, #2e1153, #dedbf1, #ff7f00, #dedbf1);
        background: linear-gradient(45deg, #2e1153, #dedbf1, #ff7f00, #dedbf1);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-size: 300% 300%;
        -webkit-animation: gradient-text 12s ease infinite;
        animation: gradient-text 12s ease infinite;

    }

    @-webkit-keyframes gradient-text {
        0% {
            background-position: 0% 50%;
        }

        50% {
            background-position: 100% 50%;
        }

        100% {
            background-position: 0% 50%;
        }
    }

    @keyframes gradient-text {
        0% {
            background-position: 0% 50%;
        }

        50% {
            background-position: 100% 50%;
        }

        100% {
            background-position: 0% 50%;
        }
    }

    /* new */
    /* body {
        font-family: 'Roboto', sans-serif;
    } */
    body, button, html, input, select, textarea {
        color: #343434 !important;
        font-family: 'Quicksand', sans-serif !important;
        line-height: 1.4 !important;
        text-rendering: optimizeLegibility !important;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased !important;
        -moz-font-smoothing: antialiased;
        -o-font-smoothing: antialiased;
    }
    
    .form-box {
        box-shadow: rgb(0 0 0 / 16%) 0 10px 12px -10px;
        border: none;
        text-align: center;
        height: calc(29px + 5px) !important;
    }

    .day-1 {
        background-color: #2e1153 !important;
        color: white;
        padding: 3px 6px !important;
        border-radius: 7px 0px 0px 7px;
    }

    .day-7 {
        border-left: 1px solid #eee;
        background-color: #ffffff;
        padding: 3px 6px !important;
    }

    .day-30 {
        border-left: 1px solid #eee;
        background-color: #ffffff;
        padding: 3px 6px !important;
        border-radius: 0px 7px 7px 0px;
    }

    .first_box {
        background-color: #017cf70f;
        padding: 7px;
        border-radius: 8px;
        font-size: 13px;
        width: 24%;
    }

    .second_box {
        background-color: #dedbf18a;
        padding: 7px;
        border-radius: 8px;
        font-size: 13px;
        width: 24%;
    }

    .count {
        padding: 2px 0px !important;
        border-radius: 7px;
        margin-bottom: 0px !important;
        color: #141639c4;
        font-weight: 500 !important;
        font-size: 13px;
        width: 28px;
        height: 21px;
        text-align: center;

    }

    .left3 {
        width: 13%;
        text-align: center;
        background-color: #354A8E;
        border-radius: 6px;
        line-height: 1;
        height: 35px !important;
    }

    .left4 {
        width: 13%;
        text-align: center;
        background-color: #C60000;
        border-radius: 6px;
        line-height: 1;
        height: 35px !important;
    }

    .title1 {
        margin-bottom: 0px !important;
        color: white;
        font-weight: 400 !important;
        font-size: 12px;
    }

    .title2 {
        margin-bottom: 0px !important;
        color: white;
        font-weight: 500 !important;
        font-size: 12px;
    }

    .progress {
        background-color: white !important;
        color: #00a8ff;
        height: 6px;
    }

    .progress-bar {
        -webkit-border-radius: 0;
        border-radius: 0;
        background-color: #a2a7b1 !important;
        height: 12px;
        font-size: 11px;
        line-height: 13px;
    }

    .counter {
        margin-top: 6px;
        font-size: 12px;
        margin-left: 19px;
        background-color: white;
        padding: 2.6px 2px;
        height: 16px;
        border-radius: 10px;
        color: #e86310;
        font-weight: 500;
        cursor: pointer;
        width: 16px;
    }

    /* .counter_box{
        background-image: linear-gradient(9deg,#282560 46%,#f5f4fd 94%);
        padding: 5px 3px 2px 2px;
        font-size: 12px;
        border-radius: 3px;
        color: white;
    } */
    /* .counter_box{
        background-image: linear-gradient(90deg,rgba(46,17,83,.19),#f5f4fd);
        font-size: 11px;
        color: #282560;
        text-align:center;
        
        background-color: rgb(46 17 83 / 10%);
        font-weight: 500;
        width: 24%;
        height: 38px;
        text-align: center;
        border-radius: 6px;
        line-height: 1;
    } */
    .counter_box {
        text-align: center;
        background-color: rgb(46 17 83 / 10%);
        border-radius: 6px;
        line-height: 1;
        width: 42%;
        height: 51px;
    }

    .top_application {
        width: 100%;
    }

    .app-content {
        float: left;
        width: 100%;
        background: #fff;
        padding: 0px 12px 12px;
    }

    .student_list {
        width: 100%;
    }

    .student_list .top-head .bordered-box {
        background: none;
    }

    .scroll_bar_lead_list .student_list .bordered-box {
        margin-bottom: 0;
    }

    .student_list .bordered-box {
        border: 1px solid #dbe4ea;
        float: left;
        width: 100%;
        display: flex;
    }

    .bordered-box {
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        justify-content: space-between;
        border-bottom: 1px solid #e9f0f3 !important;
    }

    .student_list .bordered-box .inner-box:last-child {
        border-right: none;
    }

    .student_list .bordered-box .inner-box {
        padding: 4px 0px;
        align-self: center;
    }

    .bottom-box {
        width: 100%;
        float: left;
    }

    .scroll_bar_lead_list .student_list .bordered-box {
        margin-bottom: 0;
    }

    .student_list .bordered-box {
        border: 1px solid #dbe4ea;
        float: left;
        width: 100%;
        display: flex;
        background: #fff;
    }

    .bordered-box {
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        justify-content: space-between;
        border-bottom: 1px solid #e9f0f3 !important;
    }

    .img_box {
        text-align: left !important;
    }

    .img_box {
        width: 100%;
    }

    #chart {
        max-width: 650px;
        margin: 75px auto;
        width: 100%;
    }

    .box-typical.box-typical-dashboard .box-typical-body {
        height: 298px;
        overflow-y: hidden;
        /* min-height: 298px; */
        overflow-x: hidden;
    }

    .apexcharts-legend {
        top: 0px !important;
        overflow: hidden !important;
    }

    .headline {
        color: #000000d9;
        text-align: center;
        font-weight: 600 !important;
        padding: 9px !important;
        border-radius: 5px;
    }

    .second_line {
        border-radius: 3px;
        padding: 10px 0px;
        font-size: 13px;
    }

    .title {
/*         margin-bottom: 0px !important; */
        color: #141639c4;
        font-weight: 400 !important;
        font-size: 1.2rem;
    }

    .box-1 {
        font-size: 12px;
        font-weight: 600;
        width: 35px !important;
        text-align: center;
        margin-right: 15px;
    }

    .box-3 {
        font-size: 12px;
        font-weight: 600;
        width: 52px !important;
        margin-right: 15px;
    }

    .box-4 {
        font-size: 12px;
        font-weight: 600;
        width: calc(100% - 265px) !important;
        margin-right: 15px;
    }

    .box-6 {
        font-size: 12px;
        font-weight: 600;
        width: 140px;
    }

    .tabs-section-nav {
        overflow: hidden !important;
        border-top: none !important;
    }

    .tabs-section-nav.tabs-section-nav-left .nav {
        border: none !important;
    }

    .tabs-section-nav .nav-item:first-child .nav-link {
        border: none !important;
    }

    .tabs-section-nav .nav-link.active .nav-link-in {
        padding: 2.5px 16px;
        background-image: linear-gradient(to bottom, #ff8808, #ff98006b);
        color: white;
        font-weight: bold;
        border-radius: 7px;
        box-shadow: rgb(0 0 0 / 26%) 0 8px 7px -4px;
        border-top-color: unset !important;
    }

    .tabs-section-nav.tabs-section-nav-left .nav {
        background-color: unset !important;
        border-radius: 5px;

    }

    .tabs-section-nav .nav-link-in {
        padding: 4px 0px 3px 0px;
        border-top: none !important;
    }

    .tabs-section-nav.tabs-section-nav-left .nav-item:last-child .nav-link.active {
        border: none !important;
    }

    .tabs-section-nav .nav-link.active {
        background-color: unset !important;
    }

    .tabs-section-nav .nav-item {
        background: unset !important;
    }

    .tabs-section-nav.tabs-section-nav-left .nav-item {
        margin-bottom: -8px;
    }

    .tabs-section-nav .nav-link.active {
        border-left-color: unset !important;
        border-right-color: unset !important;
    }

    .tabs-section-nav .nav-link {
        border: none !important;
    }

    .tooltip {
        position: relative;
        display: inline-block;
        opacity: 1;
    }

    .tooltip .tooltiptext {
        visibility: hidden;
        width: 85px;
        background-color: #555;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        margin-left: -44px;
        transition: opacity 0.3s;
    }

    .tooltip .tooltiptext::after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #555 transparent transparent transparent;
    }

    .tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
    }

    .status_1 {
        background-color: darkgray;
        color: white;
    }

    .status_1:hover,
    .status_1:focus {
        background-color: white;
        color: darkgray;
        border: 1px solid darkgray;
    }

    .status_2 {
        background-color: #f1a438;
        color: white;
    }

    .status_2:hover,
    .status_2:focus {
        background-color: white;
        color: #f1a438;
        border: 1px solid #f1a438;
    }

    .status_3 {
        background-color: white;
        width: 40px !important
    }

    .status_3:hover,
    .status_3:focus {
        background-color: white;
        color: black;
        border: 1px solid #00BCD4;
    }

    .status_4 {
        background-color: rgb(146, 208, 80);
        color: white;
    }

    .status_4:hover,
    .status_4:focus {
        background-color: white;
        color: rgb(146, 208, 80);
        border: 1px solid rgb(146, 208, 80);
    }

    .status_5 {
        background-color: purple;
        color: white;
    }

    .status_5:hover,
    .status_5:focus {
        background-color: white;
        color: purple;
        border: 1px solid purple;
    }

    .status_6 {
        background-color: darkblue;
        color: white;
    }

    .status_6:hover,
    .status_6:focus {
        background-color: white;
        color: darkblue;
        border: 1px solid darkblue;
    }

    .status_7 {
        background-color: #c00000;
        color: white;
    }

    .status_7:hover,
    .status_7:focus {
        background-color: white;
        color: #c00000;
        border: 1px solid #c00000;
    }

    .d_counter {
        background-color: white;
        border-radius: 14px;
        padding: 4px;
        width: 18%;
        font-size: 13px;
    }

    .t_deposit {
        /* padding: 10px;  */
        background-color: rgba(54, 104, 138, 0.92);
        border-radius: 5px;
        width: 47%;
        text-align: -webkit-center;
        height: 65px;
    }
    .back_btn{
        background: #fff;
        padding: 6px 12px;
        line-height: 22px;
        border: 1px solid #d8e2e7;
        border-radius: 1.25rem;
        letter-spacing: .2px;
        font-size: 14px;
        color: #888888;
        margin-right: 16px;
    }
    .back_btn:hover{
        background: #c0c0c0;
        transition: 0.3s;
        border-color: #d8e2e7;
        color: #fff;
    }

    .img-style{
        width: 19px !important;
        height: 19px !important;
        border-radius: 40px;
        border: 1.5px solid rgb(255, 255, 255);
        margin-left: 0px;
    }
    .btn.btn-secondary{
        background-color: unset !important;
        border-color: unset !important;
        border:none !important;
    }
    .btn.btn-secondary:hover {
        background-color: unset !important;
        border-color: unset !important;
        border:none !important;
    }

    .bootstrap_dropdown div.dropdown_icon i {
        color: #826aa0;
        background: #dedbf1;
        padding: 4px 8px;
        border-radius: 50%;
        font-size: .63rem;
        border: 1px solid transparent;
        color: #2e1153;
        cursor: pointer;
    }
    .bootstrap_dropdown div.dropdown_icon i:hover {
        color: #ff7f00!important;
        transition: all 1s cubic-bezier(.19,1,.22,1) 0s;
        border: 1px solid #ff7f00;
    }
    ul.dropdown-menu.show {
        margin-left: -120px;
        background: #dedbf1;
        transform: translate3d(-11px,25px,0)!important;
        padding: 0!important;
        min-width: 64px!important;
        right: -11px!important;
        left: auto!important;
        top: 2px!important;
    }

    ul.dropdown-menu {
        border-color: #d8e2e7;
        margin-top: -4px!important;
        font-size: .8125rem;
    }
    .checkbox-detailed {
    display: inline-block;
    vertical-align: top;
    margin: 0 12px 12px 0;
  }

  .checkbox-detailed input:checked+label {
    background-color: #e4f6fe;
    border-color: #00a8ff;
  }

  .checkbox-detailed input+label {
    width: 100px;
    height: 35px;
  }

  .checkbox-detailed input+label {
    /*width: 200px;
    height: 84px;*/
    border: solid 1px #d8e2e7;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    padding: 0 10px 0 50px;
    line-height: 1.4;
  }

  .checkbox input+label,
  .checkbox-bird input+label,
  .checkbox-detailed input+label,
  .checkbox-slide input+label,
  .checkbox-toggle input+label,
  .radio input+label {
    position: relative;
    display: inline-block;
    font-size: 1rem;
    min-height: 18px;
    line-height: 18px;
    cursor: pointer;
  }

  .checkbox-detailed input+label:before {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    border: solid 1px #c5d6de;
    position: absolute;
    left: 10px;
    top: 50%;
    margin-top: -6px;
    -webkit-border-radius: 50%;
    border-radius: 50%;
  }

  .checkbox input,
  .checkbox-bird input,
  .checkbox-detailed input,
  .checkbox-slide input,
  .checkbox-toggle input,
  .radio input {
    position: absolute;
    visibility: hidden;
  }

  .checkbox-detailed .checkbox-detailed-tbl {
    display: table;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 25px;
  }

  .checkbox-detailed .checkbox-detailed-cell {
    display: table-cell;
    vertical-align: middle;
    padding: 5px 0;
  }

  .checkbox-detailed .checkbox-detailed-title {
    font-size: small;
    color: #8e9fa7;
    font-weight: 500 !important;
  }

  .checkbox-detailed input:checked+label:before {
    border-color: #00a8ff;
    background-color: #00a8ff;
  }

  .destination_div {
    position: relative;
    width: 100%;
    height: 100px;
    border: 1px solid #ddd;
    border-radius: 3%;
    cursor: pointer;
    text-align: center;
    display: flex;
    vertical-align: middle;
    justify-content: center;
  }

  .destination_div .country_div {
    font-weight: bold;
    font-size: 12px;
    margin-bottom: 0px;
  }

  .country_div {
    width: 100%;
    position: absolute;
    bottom: 13%;
    text-align: center;
  }

  .flag_img {
    width: 35px;
    margin-top: 54%;
    border-radius: 10%;
    border-radius: 50%;
    /* height: 35px; */
    height: 35px;
  }

  .labelOfficeDiv {
    width: 100%;
  }

  .office_div_active {
    background: #e4f6fe !important;
  }

  .labelDiv {
    width: 100%;
  }

  .destination_div_active {
    background: #e4f6fe !important;
  }

  .country.active {
    background: #2e58a6;
  }

  .country.active .country_div {
    color: #ffffff;
  }


  /*New Style*/
  #footer {
    background: #ceccda;
  }

  #footer h5 {
    color: black;
  }

  #footer ul li a,
  #footer p a {
    color: black;
  }

  .footer-bar p {
    color: black;
  }

  .offc_info,
  .social_info {
    padding: 5px 0;
  }

  .offc_info dl dd,
  .social_info dl dd {
    margin-bottom: 0;
  }

  .offc_info dl dd span,
  .social_info dl dd span {
    color: #9e812c;
  }

  .total {
    display: flex;
    width: 100%;
  }

  .total .offc_info {
    width: 50%;
  }

  .total .social_info {
    width: 50%;
  }

</style>